import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "../../components/app-toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { APP_PATH } from "../../api/backendPath";
import { ACTIONS_GET_CLAIM_DOCUMENTS } from "../../action-types/actions";
import {
  getLocalizedMessage,
  getLocalizedErrorMessage,
} from "../../utils/messageHelper";
import i18n from "../../i18n";

export const getClaimDocuments = createAsyncThunk(
  ACTIONS_GET_CLAIM_DOCUMENTS.getDocuments,
  async ({ claimId }, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      const response = await axiosPrivate.get(
        `${process.env.REACT_APP_API_URL}${APP_PATH.claimsdocuments.replace(
          "{claimId}",
          claimId,
        )}`,
      );

      if (response?.data?.status === true || response?.status === 200) {
        return response.data;
      } else {
        const errorMessage = getLocalizedErrorMessage({ response }, i18n);
        toast.error(errorMessage);
        return rejectWithValue(response.data);
      }
    } catch (error) {
      console.error("Get claim documents error:", error);
      const errorMessage = getLocalizedErrorMessage(error, i18n);
      toast.error(errorMessage);
      return rejectWithValue(error?.response?.data || errorMessage);
    }
  },
);
